import request from '@/utils/request'

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/sys/user/list',
    method: 'get',
    params: query
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/sys/user/getInfo?userId='+userId,
    method: 'get',
  })
}
// 查询用户详细
export function getUserLogin() {
  return request({
    url: '/sys/user/info',
    method: 'get',
  })
}

// 修改用户
export function upPassword(data) {
  return request({
    url: '/sys/user/password',
    method: 'post',
    data: data
  })
}
// 新增用户
export function addUser(data) {
  return request({
    url: '/sys/user/save',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/sys/user/update',
    method: 'post',
    data: data
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/sys/user/delete?userId=' + userId,
    method: 'post'
  })
}

// 导出用户
export function exportUser(query) {
  return request({
    url: '/system/user/export',
    method: 'get',
    params: query
  })
}

// 用户密码重置
export function resetUserPwd(userId) {
  return request({
    url: '/sys/user/resetPwd?userId='+userId,
    method: 'post'
  })
}

// 用户状态修改
export function changeUserStatus(id, status) {
  return request({
    url: '/sys/user/changeState?id='+id+'&status='+status,
    method: 'post'
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data
  })
}

// 下载用户导入模板
export function importTemplate() {
  return request({
    url: '/system/user/importTemplate',
    method: 'get'
  })
}
